























import { Vue, Component, Prop } from 'vue-property-decorator';
import T from '../../lang';
import problemHistogram, { HistogramType } from './Histogram.vue';

@Component({
  components: {
    'omegaup-problem-histogram': problemHistogram,
  },
})
export default class ProblemFeedback extends Vue {
  @Prop() qualityHistogram!: number[];
  @Prop() difficultyHistogram!: number[];
  @Prop() qualityScore!: number;
  @Prop() difficultyScore!: number;

  T = T;
  HistogramType = HistogramType;

  get containerClass(): string {
    return this.qualityHistogram && this.difficultyHistogram
      ? 'col-md-6'
      : 'col-md-12';
  }
}
